<template>
  <div>
    <v-dialog v-model="show" persistent max-width="70vw" scrollable>
      <v-card flat>
        <v-banner color="primaryLight1" sticky single-line tile>
          <v-toolbar color="primaryLight1" flat dark height="50px">
            <span>Document</span>
            <v-spacer></v-spacer>
            <v-icon @click="onClose" color="grey-lighten-1">mdi-close</v-icon>
          </v-toolbar>
        </v-banner>
        <v-card-text class="ma-0 pa-0" style="height: 80vh;">
          <v-scale-transition>
            <PDFViewer
              :documentPath="filePath"
              v-if="isPDF"
            />
              <v-img
                class="bg-white"
                :src="filePath"
                width="100%"
                :aspect-ratio="1"
                v-else
                >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                    >
                    <v-progress-circular
                      indeterminate
                      color="grey-lighten-5"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img
            ></v-scale-transition>
        </v-card-text>
        <v-divider></v-divider>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { createUUID } from "../../utils/util";
import { mapActions, mapState } from "vuex";
import PDFViewer from "/src/components/dashboard/PDFViewer.vue";

export default {
  name: "ViewDocumentDialog",
  components: { PDFViewer },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      require: true
    },
  },
  data() {
    return {
      Loaderloading: false,
      documentFile: '',
      documentType: ''
    };
  },
  computed: {
     ...mapState({
      document: (state) =>
        state.document.landingPageDocumentDetails,
    }),
    LoaderText() {
      return this.$t("LoaderText");
    },
    tenantId() {
      return sessionStorage.getItem("tenantId");
    },
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || false);
      },
    },
     filePath() {
       return this.documentFile
    },
     isPDF() {
      return this.documentType === 'application/pdf'
    },
  },
   async mounted() {
    this.Loaderloading = true;
    await this.getFile()
    this.Loaderloading = false;
  },
  methods: {
    ...mapActions({
      getLandingPageDocumentById: "document/getLandingPageDocumentById",
    }),
    onClose,
    createUUID,
    async getFile(){
      const res = await this.getLandingPageDocumentById(this.id);
      var contentType = res.headers["content-type"];
      this.documentType = contentType 
      var blob = new Blob([res.data], { type: contentType });
      const url = window.URL || window.webkitURL;
      this.documentFile = url.createObjectURL(blob);      
      
    },
  async getFileContents(blob) {
      return new Promise((resolve, reject) => {
        let contents = ""
        const reader = new FileReader()
        reader.onload = function (e) {
          contents = reader.result
          resolve(contents)
        }
        reader.onerror = function (e) {
          reject(e)
        }
        reader.readAsDataURL(blob)
      })
  },

    blobToImage(blob) {
      return new Promise(resolve => {
        const url = URL.createObjectURL(blob)
        let img = new Image()
        img.onload = () => {
          URL.revokeObjectURL(url)
          resolve(img)
        }
        img.src = url
      })
    }
  },
};


function onClose() {
  this.$emit("input", false);
}
</script>

<style>
</style>